export default class SectorOfInterest {
  id: number;
  name: string;

  constructor(entity: SectorOfInterest) {
    this.id = entity.id;
    this.name = entity.name;
  }
}



// WEBPACK FOOTER //
// ./src/entities/SectorOfInterest.tsx